"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function tnb(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.6985 8.89275H11.7007L11.6783 8.99025L11.4832 9.9105H11.4608L10.176 15.375H8.54175L9.852 9.9105H7.653L6.4185 15.375H4.6215L6.255 8.625H11.7548L11.6985 8.89275ZM14.8043 8.625H17.5267C19.869 8.73225 19.6508 10.2855 19.6508 10.2855H20.25L20.0325 10.9283H19.4872C19.3245 11.5178 18.2347 11.8395 18.2347 11.8395C19.4872 12 19.4332 12.9645 19.4332 12.9645H20.0325L19.869 13.6072H19.3785C19.2532 14.4997 18.462 14.9333 17.8118 15.1395C17.4185 15.2623 17.0087 15.3237 16.5968 15.3218H13.17L14.8043 8.625ZM5.49225 9.9105H3.75L4.077 8.625H5.81925L5.49225 9.9105ZM12.9532 14.625L11.5373 11.3033L12.1365 8.73225L13.5518 11.8928L12.9532 14.625ZM17.1188 11.3033C17.3138 11.3033 17.5012 11.2282 17.6385 11.0917C17.7758 10.9552 17.8538 10.7723 17.8538 10.5803C17.8538 10.3883 17.7765 10.2045 17.6385 10.0688C17.5005 9.933 17.3138 9.85725 17.1188 9.85725H16.0575L15.7313 11.3033H17.1188ZM16.752 14.0895C17.2403 14.0895 17.6362 13.7175 17.6362 13.2593C17.6362 12.8003 17.2425 12.4282 16.752 12.4282H15.4755L15.0825 14.0895H16.752Z", fill: color }));
}
exports["default"] = tnb;
//# sourceMappingURL=tnb.js.map